import SortableContactCard from "./sortableContactCard"
import {
  DndContext,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import { SortableContext } from "@dnd-kit/sortable"
import { useState } from "react"

export const ContactList = ({
  fields,
  removeContactHandler,
  updateContactHandler,
  updateContactData,
}) => {
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor))

  const handleDragEnd = event => {
    const arr = fields.getAll()?.map(item => ({
      ...item?.contact,
      id: item?.id,
      vendor_id: item?.vendor_id,
    }))
    for (let i = 0; i < arr.length; i++) {
      updateContactData({ values: { ...arr[i], order: i }, type: "reorder" })
    }
  }

  const handleDragOver = event => {
    const { active, over } = event
    if (active.id !== over.id) {
      const data = fields.getAll()
      const oldIndex = data.findIndex(i => i.id === active.id)
      const newIndex = data.findIndex(i => i.id === over.id)
      fields.swap(oldIndex, newIndex)
    }
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
    >
      <SortableContext
        items={fields?.getAll() || []?.map(item => item?.id)}
        strategy={() => {}}
      >
        {fields.map((contact, index) => {
          const data = fields.get(index)
          const contactValues = {
            ...data?.contact,
            id: data?.id,
            vendor_id: data?.vendor_id,
          }
          return (
            <SortableContactCard
              key={index}
              removeContactHandler={removeContactHandler}
              updateContactHandler={updateContactHandler}
              contact={contact}
              contactValues={contactValues}
              id={contactValues?.id}
            />
          )
        })}
      </SortableContext>
    </DndContext>
  )
}

export default ContactList
